<template>
    <div class="card">
      <div class="card-body">
        <AjaxForm route="ProductAttribute/Add">
          <CustomInput name="title" type="text" label="عنوان" placeholder="عنوان ویژگی را وارد کنید..."></CustomInput>
          <div class="mt-2">
            <div class="mb-1">
              <h4 class="d-inline-block">مقادیر</h4>&nbsp;
              <button class="btn btn-info btn-sm" type="button" @click="addNewValue()">افزودن مقدار جدید</button>
            </div>
            <div class="row">
              <div v-for="(item,index) in values" :key="index" class="col-12 col-sm-12 col-md-4 d-flex mb-2 justify-content-between">
                <div>
                  <input type="text" name="item_titles[]" class="form-control" placeholder="مقدار..."  v-model="item.val" >
                </div>
                <div><i class="far fa-trash-can text-danger fa-2x" @click="removeValue(index)"></i></div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12 col-sm-8 col-md-5 mx-auto">
                <button class="btn btn-info btn-block" type="submit">افزودن ویژگی</button>
              </div>
            </div>
          </div>
        </AjaxForm>
      </div>
    </div>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import CustomInput from "@/components/CustomInput";
import AjaxForm from "@/components/forms/AjaxForm";
import {mapActions} from "vuex";
export default {
name: "ProductAttributeAdd",
  components: {AjaxForm, CustomInput, MasterLayout},
  data(){
    return {
      values: []
    }
  },
  async mounted()
  {
    this.setPageTitle('افزودن ویژگی محصول');
    this.setShowHead(true);
  },
  methods :{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    addNewValue(){
      this.values.push({val:''});
    },
    removeValue(index)
    {
      this.values.splice(index,1);
    }
  }
}
</script>

<style scoped>

</style>